import React from "react";

function TermsAndConditions() {
  return (
    <div className="flex flex-col items-center min-h-screen mt-20">
      <div>TermsAndConditions</div>
    </div>
  );
}

export default TermsAndConditions;
